var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"in-out"}},[_c('img',{key:_vm.currentImage,staticStyle:{"position":"absolute","left":"0","top":"0"},attrs:{"src":require(`../assets/${_vm.currentImageSrc}`)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }